import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { EmblaCarouselType } from 'embla-carousel';
import React, { useCallback, useSyncExternalStore } from 'react';
import { CarouselArrowNextIcon, CarouselArrowPreviousIcon } from '@/public/assets/svg';
import { ButtonProps, UsePrevNextButtonsType } from './types';
export const usePrevNextButtons = (emblaApi, onButtonClick) => {
  const $ = _c(17);
  let t0;
  if ($[0] !== emblaApi) {
    t0 = onStoreChange => {
      if (!emblaApi) {
        return _temp;
      }
      emblaApi.on("reInit", onStoreChange);
      emblaApi.on("select", onStoreChange);
      return () => {
        emblaApi.off("reInit", onStoreChange);
        emblaApi.off("select", onStoreChange);
      };
    };
    $[0] = emblaApi;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const subscribe = t0;
  let t1;
  if ($[2] !== emblaApi) {
    t1 = () => !emblaApi?.canScrollPrev();
    $[2] = emblaApi;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const prevBtnDisabled = useSyncExternalStore(subscribe, t1, _temp2);
  let t2;
  if ($[4] !== emblaApi) {
    t2 = () => !emblaApi?.canScrollNext();
    $[4] = emblaApi;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const nextBtnDisabled = useSyncExternalStore(subscribe, t2, _temp3);
  let t3;
  if ($[6] !== emblaApi || $[7] !== onButtonClick) {
    t3 = () => {
      if (!emblaApi) {
        return;
      }
      emblaApi.scrollPrev();
      onButtonClick?.(emblaApi);
    };
    $[6] = emblaApi;
    $[7] = onButtonClick;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onPrevButtonClick = t3;
  let t4;
  if ($[9] !== emblaApi || $[10] !== onButtonClick) {
    t4 = () => {
      if (!emblaApi) {
        return;
      }
      emblaApi.scrollNext();
      onButtonClick?.(emblaApi);
    };
    $[9] = emblaApi;
    $[10] = onButtonClick;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onNextButtonClick = t4;
  let t5;
  if ($[12] !== nextBtnDisabled || $[13] !== onNextButtonClick || $[14] !== onPrevButtonClick || $[15] !== prevBtnDisabled) {
    t5 = {
      prevBtnDisabled,
      nextBtnDisabled,
      onPrevButtonClick,
      onNextButtonClick
    };
    $[12] = nextBtnDisabled;
    $[13] = onNextButtonClick;
    $[14] = onPrevButtonClick;
    $[15] = prevBtnDisabled;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export const PrevButton: React.FC<ButtonProps> = props => {
  const $ = _c(6);
  let restProps;
  if ($[0] !== props) {
    ({
      ...restProps
    } = props);
    $[0] = props;
    $[1] = restProps;
  } else {
    restProps = $[1];
  }
  let t0;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-full w-full" viewBox="0 0 100 100" data-sentry-element="svg" data-sentry-source-file="index.tsx"><circle className="stroke-gray-200" strokeWidth="1.5" cx="50" cy="50" r="48" fill="white" data-sentry-element="circle" data-sentry-source-file="index.tsx" /></svg>;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute"><CarouselArrowPreviousIcon width={20} height={20} data-sentry-element="CarouselArrowPreviousIcon" data-sentry-source-file="index.tsx" /></div>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== restProps) {
    t2 = <button className="flex h-[2.875rem] w-[2.875rem] cursor-pointer items-center justify-center" type="button" aria-label="prev button" {...restProps} data-sentry-component="PrevButton" data-sentry-source-file="index.tsx">{t0}{t1}</button>;
    $[4] = restProps;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const NextButton: React.FC<ButtonProps> = props => {
  const $ = _c(10);
  let progress;
  let restProps;
  if ($[0] !== props) {
    ({
      progress,
      ...restProps
    } = props);
    $[0] = props;
    $[1] = progress;
    $[2] = restProps;
  } else {
    progress = $[1];
    restProps = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <circle className="stroke-gray-200" strokeWidth="1.5" cx="50" cy="50" r="48" fill="transparent" data-sentry-element="circle" data-sentry-source-file="index.tsx" />;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = `calc(301 - (301 * ${progress}) / 100)`;
  let t2;
  if ($[4] !== t1) {
    t2 = <svg className="h-full w-full" viewBox="0 0 100 100" data-sentry-element="svg" data-sentry-source-file="index.tsx">{t0}<circle className="progress-ring__circle stroke-primary-600" strokeWidth="1.5" strokeLinecap="round" cx="50" cy="50" r="48" fill="white" strokeDasharray="301" strokeDashoffset={t1} data-sentry-element="circle" data-sentry-source-file="index.tsx" /></svg>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute"><CarouselArrowNextIcon width={20} height={20} className="text-gray-600" data-sentry-element="CarouselArrowNextIcon" data-sentry-source-file="index.tsx" /></div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== restProps || $[8] !== t2) {
    t4 = <button className="relative flex h-[2.875rem] w-[2.875rem] cursor-pointer items-center justify-center" type="button" aria-label="next button" {...restProps} data-sentry-component="NextButton" data-sentry-source-file="index.tsx">{t2}{t3}</button>;
    $[7] = restProps;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
function _temp() {}
function _temp2() {
  return true;
}
function _temp3() {
  return true;
}